export default {"src":"/_next/static/media/undraw_online_learning.fa67b0fb.svg","height":500,"width":692,"blurWidth":0,"blurHeight":0};